/** Pure formatting helpers for the Live Auctions page (all times Europe/London). */

const TZ = 'Europe/London';

export function gbp(pence: number | null | undefined): string {
  if (pence === null || pence === undefined) return '—';
  return '£' + Math.round(pence / 100).toLocaleString('en-GB');
}

/** Countdown text: "2d 5h", "3h 07m", "12m 04s", "Ended". */
export function fmtLeft(ms: number): string {
  if (ms <= 0) return 'Ended';
  const d = Math.floor(ms / 864e5);
  const h = Math.floor((ms % 864e5) / 36e5);
  const m = Math.floor((ms % 36e5) / 6e4);
  const s = Math.floor((ms % 6e4) / 1e3);
  if (d > 0) return d + 'd ' + h + 'h';
  if (h > 0) return h + 'h ' + String(m).padStart(2, '0') + 'm';
  return m + 'm ' + String(s).padStart(2, '0') + 's';
}

export function timeOfDay(t: number): string {
  return new Date(t).toLocaleString('en-GB', { timeZone: TZ, hour: '2-digit', minute: '2-digit' });
}

function londonDate(t: number): string {
  return new Date(t).toLocaleDateString('en-GB', { timeZone: TZ });
}

export function sameLondonDay(a: number, b: number): boolean {
  return londonDate(a) === londonDate(b);
}

export function dayLabel(t: number, now: number): string {
  if (londonDate(t) === londonDate(now)) return 'Today';
  if (londonDate(t - 864e5) === londonDate(now)) return 'Tomorrow';
  return new Date(t).toLocaleDateString('en-GB', { timeZone: TZ, weekday: 'short', day: 'numeric', month: 'short' });
}

export function ago(t: number | null, now: number): string {
  if (!t) return '—';
  const m = Math.max(0, Math.round((now - t) / 6e4));
  if (m < 1) return 'just now';
  if (m < 60) return m + ' min ago';
  return Math.round(m / 60) + ' h ago';
}

/** "Apr 1997" from an ISO date (or passes a non-ISO label through). */
export function monthYear(iso: string | null | undefined): string {
  if (!iso) return '';
  const t = Date.parse(iso);
  if (isNaN(t)) return iso;
  return new Date(t).toLocaleDateString('en-GB', { timeZone: TZ, month: 'short', year: 'numeric' });
}

export function styleLabel(style: string): string {
  if (!style) return '';
  if (style.toLowerCase() === 'ni') return 'NI';
  return style.charAt(0).toUpperCase() + style.slice(1).toLowerCase();
}

export function regKey(reg: string): string {
  return (reg || '').replace(/\s/g, '').toUpperCase();
}
